import { httpClient } from '../core/http';
import {
  ConnectorProvider,
  ConnectorSource,
  ConnectorTestResponse,
  CreateConnectorSourceRequest,
  UpdateConnectorSourceRequest,
} from '../types/entities';

export class ConnectorSourceService {
  private readonly basePath = '/v1/integrations/connectors';

  async list(params?: {
    page?: number;
    page_size?: number;
    provider?: ConnectorProvider;
    scope_type?: 'organization' | 'user';
    is_active?: boolean;
  }): Promise<{
    items: ConnectorSource[];
    page: number;
    page_size: number;
    total: number;
    total_pages: number;
  }> {
    const response = await httpClient.get<{
      items: ConnectorSource[];
      page: number;
      page_size: number;
      total: number;
      total_pages: number;
    }>(this.basePath, { params });
    return response.data;
  }

  async create(payload: CreateConnectorSourceRequest): Promise<ConnectorSource> {
    const response = await httpClient.post<ConnectorSource>(this.basePath, payload);
    return response.data;
  }

  async update(
    connectorId: number,
    payload: UpdateConnectorSourceRequest
  ): Promise<ConnectorSource> {
    const response = await httpClient.patch<ConnectorSource>(
      `${this.basePath}/${connectorId}`,
      payload
    );
    return response.data;
  }

  async test(connectorId: number): Promise<ConnectorTestResponse> {
    const response = await httpClient.post<ConnectorTestResponse>(
      `${this.basePath}/${connectorId}/test`,
      {}
    );
    return response.data;
  }

  async sync(connectorId: number): Promise<{
    id: number;
    organization_id: number;
    status: 'queued' | 'completed';
    synced_at: string;
  }> {
    const response = await httpClient.post<{
      id: number;
      organization_id: number;
      status: 'queued' | 'completed';
      synced_at: string;
    }>(
      `${this.basePath}/${connectorId}/sync`,
      {}
    );
    return response.data;
  }
}

export const connectorSourceService = new ConnectorSourceService();
